import { axios } from "../../../constants/axiosConfig";
import { message } from "antd";
import moment, { duration } from "moment";

const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));
const BASE_URL = icmsModule
? process.env.REACT_APP_APICLOUD_URL_ICMS
: process.env.REACT_APP_APICLOUD_URL;

export function getApuracaoResultado() {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return axios.get(`apuracao/${cnpj}/resultado`);
}

// Retornar lista de resultados apuração
export function getResults(pCnpj) {
  const aux = JSON.parse(sessionStorage.getItem("eRecuperadorCompany"));
  const cnpj = aux !== null ? aux.Cnpj : pCnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_RESULTS_REQUEST" });
    await axios
      .get(`resultados/${cnpj}`)
      .then((response) => {
        dispatch({ type: "GET_RESULTS_SUCCESS", payload: response.data });
        return response;
      })
      .catch(() => dispatch({ type: "GET_RESULTS_FAILURE" }));
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

export function downloadRelatorioResultados(isPdf) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return (dispatch) => {
    if (isPdf) {
      dispatch({ type: "GET_REQUEST_RELATORIO_RESULTADO_PDF" });
    } else {
      dispatch({ type: "GET_REQUEST_RELATORIO_RESULTADO_EXCEL" });
    }

    fetch(`${BASE_URL}/resultados/relatorio/${cnpj}/${isPdf}`, {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          const formattedDate = moment().format("DD-MM-YYYY HH:mm:ss");
          const extensao = isPdf ? "PDF" : "EXCEL";
          const fileName = `${cnpj}-${formattedDate}-${extensao}.zip`;
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
            /* inserido o reload abaixo como forma paliativa para não gerar o loop de requisições - Leonardo (16/09) */
            //window.location.reload();
          });

          if (response.status === 400) {
            message.error("Não foi possível gerar o relatório");
          }
        }
      })
      .catch((err) => {
        message.error("Não foi possível gerar o relatório");
      })
      .finally(() => {
        if (isPdf) {
          dispatch({ type: "GET_REQUEST_RELATORIO_RESULTADO_PDF_FINISH" });
        } else {
          dispatch({ type: "GET_REQUEST_RELATORIO_RESULTADO_EXCEL_FINISH" });
        }
      });
  };
}

// Retornar item de resultados apuração
export function getResult(id) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_RESULT_REQUEST" });
    await axios.get(`resultados/${cnpj}/${id}`).then((response) => {
      dispatch({ type: "GET_RESULT_SUCCESS", payload: response.data });
    });
  };
}

// Deletar resultado
export function deleteResult(id) {
  return async (dispatch) => {
    dispatch({ type: "DELETE_RESULT_REQUEST" });
    await axios
      .delete(`resultados/${id}`)
      .then((response) => {
        dispatch({
          type: "DELETE_RESULT_SUCCESS",
          payload: response.data,
        });
        if (response.data?.StatusCode === 200) {
          message.success("Resultado excluído com sucesso");
        }
      })
      .catch(() => dispatch({ type: "DELETE_RESULT_FAILURE" }));
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

export function reprocessResult(id) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_RESULTS_REQUEST" });
    await axios
      .post(`resultados/${id}/${cnpj}/reprocessar/resultado`)
      .then((response) => {

        if (response.data.Mensagem !== null && response.data.Mensagem !== undefined && response.data.Mensagem !== "") {
          message.open({
            type: 'warning',
            content: response.data.Mensagem,
            duration: 10,
          });
        }

        dispatch({ type: "GET_RESULTS_SUCCESS", payload: response.data });
      })
      .catch(() => dispatch({ type: "GET_RESULTS_FAILURE" }));
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

export function checkReprocess(id) {
  return async (dispatch) => {
    dispatch({ type: "GET_RESULTS_REQUEST" });
    await axios
      .post(`resultados/${id}/reprocessar/check`)
      .then((response) => {
        dispatch({ type: "GET_RESULTS_SUCCESS", payload: response.data });
      })
      .catch(() => dispatch({ type: "GET_RESULTS_FAILURE" }));
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

export function checkAllReprocess(checked) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_RESULTS_REQUEST" });
    await axios
      .post(`resultados/${cnpj}/reprocessar/check/all`, checked)
      .then((response) => {
        dispatch({ type: "GET_RESULTS_SUCCESS", payload: response.data });
      })
      .catch(() => dispatch({ type: "GET_RESULTS_FAILURE" }));
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

// Retornar lista de detalhamento da segregação
export function getSegregations(period) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_SEGREGATIONS_REQUEST" });
    await axios
      .get(`resultados/segregacao/${cnpj}/${period.month}/${period.year}`)
      .then((response) => {
        dispatch({ type: "GET_SEGREGATIONS_SUCCESS", payload: response.data });
      });
  };
}

// Retornar lista de produtos analíticos
export function getAnalyticalProducts(period, filters) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_ANALYTICAL_PRODUCTS_REQUEST" });
    await axios
      .get(
        `movimentacao/historico/${cnpj}/${period.month}/${period.year}/${
          filters ? filters : ""
        }`
      )
      .then((response) => {
        dispatch({
          type: "GET_ANALYTICAL_PRODUCTS_SUCCESS",
          payload: response.data,
        });
      });
  };
}

// Retornar lista de produtos de entrada e devolução
export function getDevolutionProducts(period, filters) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "GET_DEVOLUTION_PRODUCTS_REQUEST" });
    await axios
      .get(
        `movimentacao/historico/devolucao/${cnpj}/${period.month}/${
          period.year
        }/${filters ? filters : ""}`
      )
      .then((response) => {
        dispatch({
          type: "GET_DEVOLUTION_PRODUCTS_SUCCESS",
          payload: response.data,
        });
      });
  };
}

// Download relatório de movimentações
export function downloadConsideredReport(period) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return (dispatch) => {
    dispatch({ type: "DOWNLOAD_ANALYTICAL_PRODUCTS_REQUEST" });
    fetch(
      `${BASE_URL}/relatorio/movimentacao/${cnpj}/${period.month}/${period.year}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
        }),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          const fileName = `relatório-${cnpj}-${period.month}-${period.year}.zip`;
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
            /* inserido o reload abaixo como forma paliativa para não gerar o loop de requisições - Leonardo (16/09) */
            //window.location.reload();
          });

          dispatch({
            type: "DOWNLOAD_ANALYTICAL_PRODUCTS_SUCCESS",
            payload: response,
          });
        }

        if (response.status === 400) {
          dispatch({
            type: "DOWNLOAD_ANALYTICAL_PRODUCTS_FAILURE",
          });
          message.error("Não foi possível gerar o relatório");
        }
      })
      .catch(() => {
        message.error("Não foi possível gerar o relatório");
        dispatch({
          type: "DOWNLOAD_ANALYTICAL_PRODUCTS_FAILURE",
        });
      });
  };
}

// Download relatório de movimentações
export function downloadDevolutionConsideredReport(period) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return (dispatch) => {
    dispatch({ type: "DOWNLOAD_ANALYTICAL_PRODUCTS_REQUEST" });
    fetch(
      `${BASE_URL}/relatorio/movimentacao/devolucao/${cnpj}/${period.month}/${period.year}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
        }),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          const fileName = `relatório-${cnpj}-${period.month}-${period.year}.zip`;
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
            /* inserido o reload abaixo como forma paliativa para não gerar o loop de requisições - Leonardo (16/09) */
            //window.location.reload();
          });

          dispatch({
            type: "DOWNLOAD_ANALYTICAL_PRODUCTS_SUCCESS",
            payload: response,
          });
        }

        if (response.status === 400) {
          dispatch({
            type: "DOWNLOAD_ANALYTICAL_PRODUCTS_FAILURE",
          });
          message.error("Não foi possível gerar o relatório");
        }
      })
      .catch(() => {
        message.error("Não foi possível gerar o relatório");
        dispatch({
          type: "DOWNLOAD_ANALYTICAL_PRODUCTS_FAILURE",
        });
      });
  };
}

// Mudar "considera receita" CFOP
export function changeRecipeCfop(data) {
  return async (dispatch) => {
    dispatch({ type: "CHANGE_RECIPE_CFOP_REQUEST" });
    await axios
      .post(`cfop/adicionar/${data.Id}`, data.Diff)
      .then((response) => {
        dispatch({
          type: "CHANGE_RECIPE_CFOP_SUCCESS",
          payload: response.data,
        });
        message.success("Receitas alteradas com sucesso");
      })
      .catch(() =>
        dispatch({
          type: "CHANGE_RECIPE_CFOP_FAILURE",
        })
      );
  };
}

// Aceitar arredondamento para resultado
export function acceptRouding(id) {
  return async (dispatch) => {
    dispatch({ type: "ACCEPT_ROUDING_REQUEST" });
    await axios
      .post(`resultados/aceita/arredondamento/${id}`)
      .then((response) => {
        dispatch({
          type: "ACCEPT_ROUDING_SUCCESS",
          payload: response.data,
        });
      })
      .catch((err) => console.log("erro accept rounding=> " + err)); //dispatch({ type: "ACCEPT_ROUDING_FAILURE" }));
  };
}

// Aceitar arredondamento para resultado
export function acceptDivergence(id) {
  return async (dispatch) => {
    dispatch({ type: "ACCEPT_DIVERGENCE_REQUEST" });
    await axios
      .post(`resultados/aceita/visualizar/extrato/${id}`)
      .then((response) => {
        dispatch({
          type: "ACCEPT_DIVERGENCE_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "ACCEPT_DIVERGENCE_FAILURE" }));
  };
}

// Aceitar desconto para resultado
export function setDiscount(id) {
  return async (dispatch) => {
    dispatch({ type: "SET_DISCOUNT_REQUEST" });
    await axios
      .post(`resultados/${id}/check/desconto`)
      .then((response) => {
        dispatch({
          type: "SET_DISCOUNT_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "SET_DISCOUNT_FAILURE" }));
  };
}

// Aceitar devolução para resultado
export function setDevolution(id) {
  return async (dispatch) => {
    dispatch({ type: "SET_DEVOLUTION_REQUEST" });
    await axios
      .post(`resultados/${id}/check/devolucao`)
      .then((response) => {
        dispatch({
          type: "SET_DEVOLUTION_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "SET_DEVOLUTION_FAILURE" }));
  };
}

// Aceitar Frete para resultado
export function setFreight(id) {
  return async (dispatch) => {
    dispatch({ type: "SET_FREIGHT_REQUEST" });
    await axios
      .post(`resultados/${id}/check/frete`)
      .then((response) => {
        dispatch({
          type: "SET_FREIGHT_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "SET_FREIGHT_FAILURE" }));
  };
}

// Aceitar valores de acréscimos para resultado
export function setAddition(id) {
  return async (dispatch) => {
    dispatch({ type: "SET_ADDITION_REQUEST" });
    await axios
      .post(`resultados/${id}/check/valorAcrescido`)
      .then((response) => {
        dispatch({
          type: "SET_ADDITION_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "SET_ADDITION_FAILURE" }));
  };
}


// Aceitar valores de outras despesas para resultado
export function setOutrasDespesas(id) {
  return async (dispatch) => {
    dispatch({ type: "SET_OUTRAS_DESPESAS_REQUEST" });
    await axios
      .post(`resultados/${id}/check/valorOutrasDespesas`)
      .then((response) => {
        dispatch({
          type: "SET_OUTRAS_DESPESAS_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "SET_OUTRAS_DESPESAS_FAILURE" }));
  };
}

export function acceptNextDuplicated(mes, ano, isIcms) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "ACCEPT_DUPLICATED_REQUEST" });
    await axios
      .post(
        `produto/${
          isIcms ? "icms/" : ""
        }${cnpj}/${mes}/${ano}/divergencia/classificacao/prosseguir`
      )
      .then((response) => {
        dispatch({ type: "ACCEPT_DUPLICATED_SUCCESS" });
      })
      .catch(() => {
        dispatch({ type: "ACCEPT_DUPLICATED_FAILURE" });
      });
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

export function acceptNextClassify(mes, ano, isIcms) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    dispatch({ type: "ACCEPT_DUPLICATED_REQUEST" });
    await axios
      .post(
        `produto/${
          isIcms ? "icms/" : ""
        }${cnpj}/${mes}/${ano}/divergencia/classificacao/prosseguir/classificacao`
      )
      .then((response) => {
        dispatch({ type: "ACCEPT_DUPLICATED_SUCCESS" });
      })
      .catch(() => {
        dispatch({ type: "ACCEPT_DUPLICATED_FAILURE" });
      });
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

export function solveDuplicityMovement(id, action, type) {
  return async (dispatch) => {
    dispatch({ type: "SOLVE_MOVEMENT_REQUEST" });
    await axios
      .post(`resultados/${id}/movimentacao/${action}/${type}`)
      .then((response) => {
        dispatch({ type: "SOLVE_MOVEMENT_SUCCESS", payload: response.data });
      })
      .catch(() => {
        dispatch({ type: "SOLVE_MOVEMENT_FAILURE" });
      });
  };
}

export function notificarNovoResultado(idImportacao) {
  return axios
    .post(`resultados/notificar/${idImportacao}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

// Bloquear competencia
export function blockCompetence(id,status) {
  return async (dispatch) => {
    dispatch({ type: "BLOCK_COMPETENCE_REQUEST" });
    await axios
      .put(`apuracao/${id}/bloquearApuracao`)
      .then((response) => {
        dispatch({ type: "BLOCK_COMPETENCE_SUCCESS", payload: response.data });
        if (response.data?.StatusCode === 200) {
          if(status){
            message.success("Apuração descongelada com sucesso");
          }else{
            message.success("Apuração congelada com sucesso");
          }
        }
      })
      .catch(() => dispatch({ type: "BLOCK_COMPETENCE_FAILURE" }));
    dispatch({ type: "RESULTS_CLEAN" });
  };
}

